import(/* webpackMode: "eager" */ "/vercel/path0/app/leaderboard/page.tsx");
